const overlayId = 'app-loader';
const textClass = 'app-loader__text';
let overlayElement = null;
let textElement = null;
let activeRequests = 0;

function ensureElements() {
    if (!overlayElement) {
        overlayElement = document.getElementById(overlayId);
        textElement = overlayElement ? overlayElement.querySelector(`.${textClass}`) : null;
    }
}

function applyVisibility() {
    if (!overlayElement) {
        return;
    }

    if (activeRequests > 0) {
        overlayElement.classList.add('is-visible');
        overlayElement.setAttribute('aria-hidden', 'false');
        overlayElement.setAttribute('aria-busy', 'true');
    } else {
        overlayElement.classList.remove('is-visible');
        overlayElement.setAttribute('aria-hidden', 'true');
        overlayElement.setAttribute('aria-busy', 'false');
    }
}

export function showLoader(message) {
    ensureElements();
    if (!overlayElement) {
        return;
    }

    if (typeof message === 'string' && textElement) {
        textElement.textContent = message;
    }

    activeRequests += 1;
    applyVisibility();
}

export function hideLoader() {
    if (activeRequests > 0) {
        activeRequests -= 1;
    }
    applyVisibility();
}

export function setLoaderMessage(message) {
    ensureElements();
    if (textElement && typeof message === 'string') {
        textElement.textContent = message;
    }
}

export function resetLoader() {
    activeRequests = 0;
    applyVisibility();
}
